
import { deep_clone } from "@/global.functions";
import { Component, Prop, Vue } from "vue-property-decorator";
import BodyConfigImportexportElement from "./body-config/importexport-element.vue";
import { LayoutInterface } from "../store/config.types";
import { DEFAULT_LAYOUTS } from "../store/default-configs";
import BodyConfigAddLayoutComponent from "./body-config/add-layout.vue";
import HelpComponent from "./help.vue";

@Component({
  components: {
    "body-config-importexport": BodyConfigImportexportElement,
    "body-config-addlayout": BodyConfigAddLayoutComponent,
    "help": HelpComponent
  }
})
export default class BodyConfigComponent extends Vue {
  @Prop()
  value!: boolean;
  resetConfirmationDialog: boolean = false
  config: {layouts: Array<LayoutInterface>, activeLayoutIndex: number, nextEventPopupEnabled: boolean} = {
    layouts: deep_clone(this.$store.getters["config/getLayout"]()),
    activeLayoutIndex: deep_clone(this.$store.getters["config/getActiveLayoutIndex"]()),
    nextEventPopupEnabled: deep_clone(this.$store.getters["config/getNextEventPopup"]())
  }
  contextHelp: string = "## General Settings\nHere you can configure the layout. You can add various layouts and select the currently active. Remember: This view sets up only the different layouts. The tiles are configured when one layout is enabled via the **Edit tiles** button in the menu. With the two buttons at the top right of the dialog, you can export and import the settings."

  get nextEventPopupEnabled(): boolean {
    return this.config.nextEventPopupEnabled
  }
  set nextEventPopupEnabled(value: boolean) {
    Vue.set(this.config, "nextEventPopupEnabled", value)
  }

  get show(): boolean {
    return this.value
  }
  set show(value: boolean) {
    this.$emit("input", value)
  }

  get layouts() {
    return this.config.layouts
  }
  set layouts(value: Array<LayoutInterface>) {
    Vue.set(this.config, "layouts", value)
  }

  get activeLayoutIndex() {
    return this.config.activeLayoutIndex
  }
  set activeLayoutIndex(value: number) {
    Vue.set(this.config, "activeLayoutIndex", value)
  }

  addLayout(layout: LayoutInterface) {
    this.layouts.push(layout)
  }

  removeLayout(i: number) {
    this.layouts.splice(i, 1)
  }

  appendDefaultLayout() {
    this.layouts.push(...DEFAULT_LAYOUTS)
  }

  resetSettings() {
    this.resetConfirmationDialog = false
    this.$store.dispatch('config/resetAllConfig')
  }

  save() {
    this.$store.dispatch('config/updateLayouts', this.layouts)
    this.$store.dispatch('config/updateActiveLayoutIndex', this.activeLayoutIndex)
    this.$store.dispatch('config/updateNextEventPopup', this.nextEventPopupEnabled)
    this.show = false
  }

  cancel() {
    Vue.set(this.config, "layouts", deep_clone(this.$store.getters["config/getLayout"]()))
    Vue.set(this.config, "activeLayoutIndex", deep_clone(this.$store.getters["config/getActiveLayoutIndex"]()))
    this.show = false
  }
}
